import React from 'react';

const Twitter = () => (
	<svg viewBox="0 0 44 44" className="icon twitter">
		<path d="M22.55,12v4.39h4v2.12h-4v8.25c0,1.9.54,3,2.08,3a6.18,6.18,0,0,0,1.61-.19l.13,2.08a6.8,6.8,0,0,1-2.46.38,3.85,3.85,0,0,1-3-1.17c-.79-.82-1.07-2.18-1.07-4V18.51H17.47V16.39h2.37V12.73Z" fill="#009fe3" stroke="#009fe3" strokeMiterlimit="10" />
  </svg>
);

export default Twitter;
